/**
 * @prettier
 * @flow
 */
import { es } from 'src/translations/es';
import { en } from 'src/translations/en';
import { getLanguage } from 'src/utils/translate/language';

export function translate(text: string, data?: { [string]: string | number  | void }) {
    const language = getLanguage();
    if (language.startsWith('es')) {
        return replaceData(es[text] ?? text, data);
    }
    return replaceData(en[text] ?? text, data);
}

function replaceData(text: string, data?: { [string]: string | number  | void }) {
    if (!text || !data) {
        return text;
    }
    return Object.entries(data).reduce((result, entry) => {
        const [key, value]: [string, string] = (entry: any);
        return result.replace(new RegExp(`@${key}`, 'g'), value || '');
    }, text);
}
